import { Directive, OnInit, inject } from '@angular/core';
import { catchError, EMPTY, Observable } from 'rxjs';
import { CourseInstancesResponseDTO } from '../course/models/CourseDTO';
import { CourseService } from '../course/services/course.service';
import { SnackbarService } from '../../../core/services/snackbar.service';
import { CustomPortalError } from '../../../core/errors/models/CustomPortalError';
import { LearningPlanInstancesResponseDTO } from '../learning-plan/models/LearningPlanDTO';
import { LearningPlanService } from '../learning-plan/services/learning-plan.service';

@Directive()
export abstract class CourseInstanceOverviewBaseComponent implements OnInit {
  private readonly courseService = inject(CourseService);
  private readonly snackbarService = inject(SnackbarService);
  private readonly learningPlanService = inject(LearningPlanService);

  courseInstancesRes$: Observable<CourseInstancesResponseDTO>;
  learningPlanInstancesRes$: Observable<LearningPlanInstancesResponseDTO>;

  ngOnInit(): void {
    this.courseInstancesRes$ = this.courseService.getCourseInstances().pipe(
      catchError((error: CustomPortalError) => {
        this.snackbarService.error(error.errorType);
        return EMPTY;
      }),
    );
    this.learningPlanInstancesRes$ = this.learningPlanService
      .getLearningPlanInstances()
      .pipe(
        catchError((error: CustomPortalError) => {
          this.snackbarService.error(error.errorType);
          return EMPTY;
        }),
      );
  }
}
